const asset = (name) => `${process.env.PUBLIC_URL}/sbhrp/${name}`;
const attachment = (name) => `${process.env.PUBLIC_URL}/sbhrp/attachment/${encodeURIComponent(name)}`;
const partnerAsset = (name) => `${process.env.PUBLIC_URL}/sbhrp/partners/${name}`;

const sbhrpContent = {
  ar: {
    title: 'مشروع تعزيز أطر الأعمال التجارية وحقوق الإنسان في فلسطين (SBHRP)',
    homeExcerpt:
      'يعمل المشروع على دعم القطاع الخاص الفلسطيني لتبني ممارسات أعمال أكثر مسؤولية وشمولاً واحتراماً لحقوق الإنسان، بما ينسجم مع المبادئ التوجيهية للأمم المتحدة بشأن الأعمال التجارية وحقوق الإنسان.',
    homeImage: asset('image12.png'),
    homeImageAlt: 'شعار مشروع الأعمال التجارية وحقوق الإنسان',
    meta: [
      { type: 'duration', label: 'مدة المشروع', value: '6 شهور\n(كانون أول 2025 – أيار 2026)' },
      { type: 'budget', label: 'ميزانية المشروع', value: '59,492 $' },
      {
        type: 'funding',
        label: 'بتمويل من',
        value: 'برنامج الأمم المتحدة الإنمائي\nبرنامج مساعدة الشعب الفلسطيني (UNDP/PAPP)',
      },
    ],
    sdgTitle: 'الأهداف المستدامة',
    sdgImages: [
      { src: asset('sdg-8.png'), alt: 'الهدف 8: العمل اللائق ونمو الاقتصاد' },
      { src: asset('sdg-10.png'), alt: 'الهدف 10: الحد من أوجه عدم المساواة' },
      { src: asset('sdg-16.png'), alt: 'الهدف 16: السلام والعدل والمؤسسات القوية' },
      { src: asset('sdg-17.png'), alt: 'الهدف 17: عقد الشراكات لتحقيق الأهداف' },
    ],
    generalTitle: 'الهدف العام',
    generalBody: [
      'يعمل مشروع «تعزيز أطر الأعمال التجارية وحقوق الإنسان في فلسطين (SBHRP)» على دعم القطاع الخاص الفلسطيني لتبني ممارسات أعمال أكثر مسؤولية وشمولاً واحتراماً لحقوق الإنسان، بما ينسجم مع المبادئ التوجيهية للأمم المتحدة بشأن الأعمال التجارية وحقوق الإنسان.',
      'ينفذ المشروع اتحاد الغرف التجارية الصناعية الزراعية الفلسطينية ضمن جهود تعزيز بيئة أعمال فلسطينية أكثر استدامة وعدالة وقدرة على مراعاة حقوق الإنسان داخل المؤسسات والشركات.',
    ],
    visionTitle: 'رؤية المشروع',
    visionBody:
      'نحو بيئة أعمال فلسطينية أكثر مسؤولية وشمولاً واستدامة، تضع حقوق الإنسان في صميم ممارساتها التشغيلية والإدارية.',
    objectivesTitle: 'أهداف المشروع',
    objectives: [
      {
        icon: 'tools',
        text: 'تطوير أدوات عملية تساعد المؤسسات على تطبيق مبادئ حقوق الإنسان في بيئة العمل.',
      },
      {
        icon: 'support',
        text: 'دعم الشركات لتطوير ممارسات أكثر توافقاً مع حقوق الإنسان.',
      },
      {
        icon: 'awareness',
        text: 'تعزيز الوعي بمفاهيم الأعمال التجارية وحقوق الإنسان داخل القطاع الخاص الفلسطيني.',
      },
      {
        icon: 'dialogue',
        text: 'تشجيع الحوار والتعاون بين القطاع الخاص والمؤسسات الحكومية والمجتمع المدني.',
      },
      {
        icon: 'inclusion',
        text: 'تعزيز مشاركة النساء والفئات المهمشة في بيئة الأعمال.',
      },
    ],
    deliverablesTitle: 'ماذا قدم المشروع؟',
    deliverables: [
      {
        icon: 'workshop',
        text: 'تنظيم ورش توعوية وجلسات تشاورية متعددة الأطراف.',
      },
      {
        icon: 'guide',
        text: 'تطوير دليل إرشادي للأعمال التجارية وحقوق الإنسان.',
      },
      {
        icon: 'operational',
        text: 'إعداد أدوات تشغيلية عملية ونماذج تطبيقية للشركات.',
      },
      {
        icon: 'incentives',
        text: 'تطوير نظام حوافز لتشجيع الامتثال الطوعي.',
      },
      {
        icon: 'lab',
        text: 'تنفيذ مختبر الابتكار وبرنامج الإرشاد التجريبي.',
      },
      {
        icon: 'legal',
        text: 'تقديم دعم فني وقانوني للشركات والمستفيدين.',
      },
    ],
    impactTitle: 'الأثر بالأرقام',
    impact: [
      {
        icon: 'participants',
        value: '+200',
        label: 'مشارك ومشاركة في أنشطة المشروع',
      },
      {
        icon: 'women',
        value: '58%',
        label: 'من المشاركين نساء',
      },
      {
        icon: 'chambers',
        value: '13',
        label: 'غرفة تجارية شاركت في المشروع',
      },
      {
        icon: 'companies',
        value: '14',
        label: 'شركة من القطاع الخاص',
      },
      {
        icon: 'activities',
        value: '12',
        label: 'نشاطاً وفعالية متنوعة',
      },
      {
        icon: 'beneficiaries',
        value: '12',
        label: 'مستفيداً ومستفيدة مع دعم قانوني',
      },
    ],
    toolsTitle: 'الأدوات العملية المطورة',
    toolsIntro:
      'ضمن المشروع تم تطوير مجموعة من الأدوات العملية لدعم التطبيق الفعلي لمبادئ حقوق الإنسان داخل الشركات، وتشمل:',
    tools: [
      { icon: 'handbook', title: 'الدليل الإرشادي' },
      { icon: 'incentives', title: 'نظام الحوافز' },
      { icon: 'ethics', title: 'الميثاق الأخلاقي' },
      { icon: 'operational', title: 'أدوات تشغيلية ونماذج تطبيقية' },
      { icon: 'toolkit', title: 'مجموعة أدوات عملية للشركات' },
    ],
    labTitle: 'مختبر الابتكار',
    labParagraphs: [
      'مثّل مختبر الابتكار مساحة تفاعلية جمعت أصحاب الأعمال الصغيرة والمتوسطة ورواد الأعمال بهدف تعزيز ثقافة الأعمال المسؤولة وربط مفاهيم الابتكار بحقوق الإنسان داخل بيئة العمل.',
      'كما ساهم المختبر في توفير التوجيه والإرشاد والدعم الفني والقانوني للمشاركين، بما يساعدهم على تطوير مبادرات أكثر شمولاً واستدامة.',
    ],
    labHighlightsTitle: 'ماذا قدم المختبر؟',
    labHighlights: [
      'جلسات إرشاد وتوجيه',
      'دعم قانوني وفني',
      'تطوير أفكار ريادية مسؤولة',
      'تعزيز التشبيك وتبادل الخبرات',
      'أدوات عملية ونماذج تطبيقية',
    ],
    attachmentsTitle: 'المرفقات',
    attachments: [
      {
        href: attachment('GuidingPrinciplesBusinessHR_AR.pdf'),
        label: 'المبادئ التوجيهية للأمم المتحدة بشأن الأعمال التجارية وحقوق الإنسان',
      },
      {
        href: attachment('FAQ_PrinciplesBussinessHR_ar.pdf'),
        label: 'الأسئلة الشائعة حول مبادئ الأعمال التجارية وحقوق الإنسان',
      },
      {
        href: attachment('مسؤولية الشركات عن احترام حقوق الإنسان.pdf'),
        label: 'مسؤولية الشركات عن احترام حقوق الإنسان',
      },
      {
        href: attachment(
          'UNDP_Heightened_Human_Rights_Due_Diligence_for_Business_in_Conflict-Affected_Contexts_EN.pdf',
        ),
        label:
          'العناية الواجبة المعزّزة لحقوق الإنسان للأعمال في سياقات النزاع (UNDP)',
      },
    ],
    partnersTitle: 'شركاء المشروع',
    partnersIntro: 'ينفذ المشروع بالشراكة مع:',
    partners: [
      {
        name: 'برنامج الأمم المتحدة الإنمائي',
        image: partnerAsset('undp-bhr.png'),
        alt: 'شعار برنامج الأمم المتحدة الإنمائي ومشروع الأعمال التجارية وحقوق الإنسان',
      },
      {
        name: 'الهيئة المستقلة لحقوق الإنسان / ديوان المظالم',
        image: partnerAsset('ichr.png'),
        alt: 'شعار الهيئة المستقلة لحقوق الإنسان / ديوان المظالم',
      },
      {
        name: 'وزارة العدل الفلسطينية',
        image: partnerAsset('justice.png'),
        alt: 'شعار دولة فلسطين — وزارة العدل الفلسطينية',
      },
    ],
    closing:
      'خطوة جديدة نحو ترسيخ ثقافة أعمال فلسطينية أكثر مسؤولية واحتراماً لحقوق الإنسان.',
  },
  en: {
    title:
      'Strengthening Business and Human Rights Frameworks in Palestine (SBHRP)',
    homeExcerpt:
      'The project supports the Palestinian private sector in adopting more responsible, inclusive business practices that respect human rights, in line with the UN Guiding Principles on Business and Human Rights.',
    homeImage: asset('image12.png'),
    homeImageAlt: 'Business and Human Rights project logo',
    meta: [
      { type: 'duration', label: 'Project duration', value: '6 months\n(Dec 2025 – May 2026)' },
      { type: 'budget', label: 'Project budget', value: '$59,492' },
      {
        type: 'funding',
        label: 'Funded by',
        value: 'UNDP / Programme of Assistance to the Palestinian People (PAPP)',
      },
    ],
    sdgTitle: 'Sustainable Development Goals',
    sdgImages: [
      { src: asset('sdg-8.png'), alt: 'SDG 8: Decent Work and Economic Growth' },
      { src: asset('sdg-10.png'), alt: 'SDG 10: Reduced Inequalities' },
      { src: asset('sdg-16.png'), alt: 'SDG 16: Peace, Justice and Strong Institutions' },
      { src: asset('sdg-17.png'), alt: 'SDG 17: Partnerships for the Goals' },
    ],
    generalTitle: 'Overall objective',
    generalBody: [
      'The SBHRP project supports the Palestinian private sector in adopting more responsible, inclusive business practices aligned with the UN Guiding Principles on Business and Human Rights.',
      'It is implemented by the Federation of Palestinian Chambers of Commerce, Industry and Agriculture to help build a more sustainable, fair business environment that upholds human rights within institutions and companies.',
    ],
    visionTitle: 'Project vision',
    visionBody:
      'Towards a more responsible, inclusive and sustainable Palestinian business environment that places human rights at the core of its operational and managerial practices.',
    objectivesTitle: 'Project objectives',
    objectives: [
      {
        icon: 'tools',
        text: 'Developing practical tools that help institutions apply human rights principles in the workplace.',
      },
      {
        icon: 'support',
        text: 'Supporting companies to develop practices more aligned with human rights.',
      },
      {
        icon: 'awareness',
        text: 'Raising awareness of business and human rights concepts within the Palestinian private sector.',
      },
      {
        icon: 'dialogue',
        text: 'Encouraging dialogue and cooperation between the private sector, government institutions and civil society.',
      },
      {
        icon: 'inclusion',
        text: 'Promoting the participation of women and marginalized groups in the business environment.',
      },
    ],
    deliverablesTitle: 'What did the project deliver?',
    deliverables: [
      {
        icon: 'workshop',
        text: 'Organising awareness workshops and multi-stakeholder consultative sessions.',
      },
      {
        icon: 'guide',
        text: 'Developing a guidance manual on business and human rights.',
      },
      {
        icon: 'operational',
        text: 'Preparing practical operational tools and application models for companies.',
      },
      {
        icon: 'incentives',
        text: 'Developing an incentives system to encourage voluntary compliance.',
      },
      {
        icon: 'lab',
        text: 'Implementing the Innovation Lab and pilot mentoring programme.',
      },
      {
        icon: 'legal',
        text: 'Providing technical and legal support to companies and beneficiaries.',
      },
    ],
    impactTitle: 'Impact in numbers',
    impact: [
      {
        icon: 'participants',
        value: '200+',
        label: 'participants in project activities',
      },
      {
        icon: 'women',
        value: '58%',
        label: 'of participants are women',
      },
      {
        icon: 'chambers',
        value: '13',
        label: 'chambers of commerce engaged',
      },
      {
        icon: 'companies',
        value: '14',
        label: 'private-sector companies',
      },
      {
        icon: 'activities',
        value: '12',
        label: 'diverse activities and events',
      },
      {
        icon: 'beneficiaries',
        value: '12',
        label: 'beneficiaries with legal support',
      },
    ],
    toolsTitle: 'Practical tools developed',
    toolsIntro:
      'The project developed a set of practical tools to support the real-world application of human rights principles inside companies, including:',
    tools: [
      { icon: 'handbook', title: 'Guidance manual' },
      { icon: 'incentives', title: 'Incentives system' },
      { icon: 'ethics', title: 'Code of ethics' },
      { icon: 'operational', title: 'Operational tools and application models' },
      { icon: 'toolkit', title: 'Practical toolkit for companies' },
    ],
    labTitle: 'Innovation Lab',
    labParagraphs: [
      'The Innovation Lab served as an interactive space that brought together small and medium business owners and entrepreneurs to promote responsible business culture and connect innovation with human rights in the workplace.',
      'The lab also provided guidance, mentoring, and technical and legal support to participants, helping them develop more inclusive and sustainable initiatives.',
    ],
    labHighlightsTitle: 'What did the lab offer?',
    labHighlights: [
      'Guidance and mentoring sessions',
      'Legal and technical support',
      'Development of responsible entrepreneurial ideas',
      'Networking and knowledge exchange',
      'Practical tools and application models',
    ],
    attachmentsTitle: 'Attachments',
    attachments: [
      {
        href: attachment('GuidingPrinciplesBusinessHR_AR.pdf'),
        label: 'UN Guiding Principles on Business and Human Rights (Arabic)',
      },
      {
        href: attachment('FAQ_PrinciplesBussinessHR_ar.pdf'),
        label: 'FAQ on Business and Human Rights Principles (Arabic)',
      },
      {
        href: attachment('مسؤولية الشركات عن احترام حقوق الإنسان.pdf'),
        label: 'Corporate responsibility to respect human rights',
      },
      {
        href: attachment(
          'UNDP_Heightened_Human_Rights_Due_Diligence_for_Business_in_Conflict-Affected_Contexts_EN.pdf',
        ),
        label:
          'Heightened Human Rights Due Diligence for Business in Conflict-Affected Contexts (UNDP)',
      },
    ],
    partnersTitle: 'Project partners',
    partnersIntro: 'The project is implemented in partnership with:',
    partners: [
      {
        name: 'United Nations Development Programme',
        image: partnerAsset('undp-bhr.png'),
        alt: 'UNDP and Business and Human Rights project logo',
      },
      {
        name: 'Independent Commission for Human Rights / Ombudsman',
        image: partnerAsset('ichr.png'),
        alt: 'Independent Commission for Human Rights / Ombudsman logo',
      },
      {
        name: 'Ministry of Justice of Palestine',
        image: partnerAsset('justice.png'),
        alt: 'State of Palestine — Ministry of Justice emblem',
      },
    ],
    closing:
      'A new step towards embedding a more responsible Palestinian business culture that respects human rights.',
  },
};

export default sbhrpContent;
